import { render } from "./PaymentDemoPage.vue?vue&type=template&id=4beeaccd&scoped=true&ts=true"
import script from "./PaymentDemoPage.vue?vue&type=script&lang=ts"
export * from "./PaymentDemoPage.vue?vue&type=script&lang=ts"

import "./PaymentDemoPage.vue?vue&type=style&index=0&id=4beeaccd&scoped=true&lang=css"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4beeaccd"]])

export default __exports__